import React from 'react';
import './newtons_cradle.css';

const NewtonsCradleLoader = () => {
  return <span className="loader"></span>;
};

export default NewtonsCradleLoader;
